<template>
  <div  class="embed-conteudo has-text-centered" v-if='data' style="margin-top:30px;">
    <div class="title is-6 has-text-weight-bold"> Recursos</div>
    <div class="subtitle is-6">
      Recursos são arquivos que você disponibiliza para seus estudantes <br /><i>(Materiais necessários ou extras para a aula)</i>.
    </div>
    <div style="max-width:600px;text-align:; margin:auto">
      <el-upload
        class="upload-demo"
         :action="`${base}/api/admin/curso/${curso_id}/upload-file`"
        :headers='{"authorization": `Bearer ${jwt}`}'
        :on-preview="handlePreview"
        :on-remove="handleRemove"
        :before-remove="beforeRemove"
        multiple
        :limit="3"
        :on-exceed="handleExceed"
        :file-list="data.arquivos">
        <el-button size="small" type="primary">Selecionar arquivo do computador</el-button>
        <div slot="tip" class="el-upload__tip">arquivos com até 8MB</div>
      </el-upload>
    </div>
    <hr />
  </div>  
</template>

<script>
  import axios from 'axios';
  export default {
    props: ['data'],
    data() {
      return {
        fileList: []
      };
    },
    computed: {
      curso_id() {
        return this.$route.params.curso;
      },
      jwt(){
        return this.$store.state.session.jwt;
      },
      base(){
        return window.base
      },
    },
    methods: {
      handleRemove(file, fileList) {
        console.log(file.response, file, fileList);
        if(file.response)
          this.removeFile(file.response);
        else
          this.removeFile(file);
      },
      handlePreview(file) {
        console.log(file);
      },
      handleExceed(files, fileList) {
        this.$message.warning(`The limit is 3, you selected ${files.length} files this time, add up to ${files.length + fileList.length} totally`);
      },
      beforeRemove(file, fileList) {
        return this.$confirm(`Remover ${ file.name }？`);
      },
      removeFile(file){
        console.log(file)
          const curso_id = this.$route.params.curso;
          global.Loading.begin(`Removendo arquivo`);
          axios({
            method: 'delete',
            url: `${global.base}/api/admin/file/${file.id}`,
            headers: { 'authorization': `bearer ${this.$store.state.session.jwt}` },
            }).then((r)=>{
              global.Loading.end();
            }).catch(()=>{
              global.Loading.end();
            })
        }
    }
  };
</script>

<style scoped>
  .embed-conteudo{

  } 

</style>